import { render } from "./carsComponent.vue?vue&type=template&id=72e38853&scoped=true"
import script from "./carsComponent.vue?vue&type=script&lang=js"
export * from "./carsComponent.vue?vue&type=script&lang=js"

import "./carsComponent.vue?vue&type=style&index=0&id=72e38853&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-72e38853"]])

export default __exports__